import { useRoutes } from 'react-router-dom';
import router from 'src/router';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { SnackbarProvider } from './components/snackbar/SnackbarProvider';
import { WalletProvider } from './components/walletcontexthook';
import { AppConfigProvider } from './components/AppConfigContext/AppConfigContext';

function App() {
  const content = useRoutes(router);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
       <SnackbarProvider>
       <WalletProvider>
        <AppConfigProvider>
            {content}
        </AppConfigProvider>
       
       </WalletProvider>

       </SnackbarProvider>
        
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
